/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_DocumentsInputs */

const cs_nav_documents = /** @type {(inputs: Nav_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smlouvy a dokumenty`)
};

const en_nav_documents = /** @type {(inputs: Nav_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contracts & Documents`)
};

/**
* | output |
* | --- |
* | "Contracts & Documents" |
*
* @param {Nav_DocumentsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_documents = /** @type {((inputs?: Nav_DocumentsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_DocumentsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_documents(inputs)
	return cs_nav_documents(inputs)
});